import { HttpErrorResponse, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SubUrlsEnum } from '../enums/sub-urls.enum';
import { mockCloud1, mockCloudRoot } from './cloud.mock';

export const mockCloudRes: any = (request: HttpRequest<any>): Observable<HttpResponse<any> | HttpErrorResponse> => {
    if (request.method === 'GET' && request.url.endsWith(SubUrlsEnum.BASE_FOLDERS)) {
        const response: any = {
            status: 200,
            body: mockCloudRoot,
        };
        return of(new HttpResponse(response));
    }

    if (request.method === 'GET' && request.url.includes('/' + SubUrlsEnum.BASE_FOLDERS + '/1')) {
        const response: any = {
            status: 200,
            body: mockCloud1,
        };
        return of(new HttpResponse(response));
    }

    return of(new HttpResponse());
};
